import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export default function sampleReducer(state = initialState.sample, action) {
	switch (action.type) {
		case types.GET_SAMPLE: {
			return action.response;
		}
		default:
			return state;
	}
}
